import React from "react";
import { Profile1 } from "constants/images";
import { LogoBlue } from "constants/images";
import { A4_SIZE } from "../../resume";


export default function TemplateFiveFullPageOne(props) {
  // ===================== props ============================
  const {
    previewImage,
    details = {},
    personal = {},
    minHeight="305mm",
    fullPreview=true
  } = props;

  return (
    <div className="w-full relative box-border" style={A4_SIZE}>
      <div className={`min-w-[816px] bg-white h-full ${fullPreview && 'px-12'}`}>
        {/* ouside padding */}
        <div className="w-full h-full">
          {/* inner padding */}
          <div className="w-full h-full p-3.5 relative">
            {/* body start */}
            <div
              className="w-full flex flex-col gap-y-5"
              style={{ height: "290mm" }}>
              {/* header */}
              <div className="w-full flex flex-row justify-center items-center">
                <div className="flex flex-col gap-y-2.5 items-center text-center">
                  <p
                    className="text-4.5xl font-bold leading-8.5 tracking-resumeName text-resumeTempFourTextPrimary"
                    // style={{ color: tertiaryColor }}
                    >
                    {personal?.name || ''}
                  </p>
                  <div className="flex flex-row gap-x-2 items-center justify-center">
                    {details?.hasOwnProperty("phone_number") && details?.phone_number && (
                      <>
                        <p className="text-xs text-resumeTempFourTextPrimary">{details.phone_number}</p>
                        <span className="opacity-30">&#8226;</span>
                      </>
                    )}
                    {details?.hasOwnProperty("email") && details?.email && (
                      <>
                        <p className="text-xs text-resumeTempFourTextPrimary">{details.email}</p>
                      </>
                    )}
                  </div>
                </div> 
              </div>
              {
                    personal?.profile_image &&
                      <div className="w-full h-full relative overflow-auto">
                        {personal?.hasOwnProperty("profile_image") ? (
                          <div
                              className="w-full h-full bg-center bg-cover"
                              style={{
                                backgroundImage: `url(${previewImage ?? personal.profile_image})`,
                              }}
                            />

                        ) : (
                          <div
                            className="w-full h-full bg-center bg-cover"
                            style={{
                              backgroundImage: `url(${Profile1})`,
                            }}
                          />

                        )}
                      </div>
                  }
            </div>
            {/* footer */}
            <div className="w-full flex items-end">
              <div className="w-full">
                <div className="w-full flex pt-3.5 justify-center gap-2 items-center">
                  <img src={LogoBlue} alt="logo" className="w-6 h-6"/> 
                  <p className="text-xs text-resumeTempFourTextPrimary leading-4 opacity-90">
                    Made with Milestone Page
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
